import { IUserTempData } from '../../interfaces/Element.interfaces';
import { getUserTempData } from '../../utils/getter/getUserTempData.util';
import {
  IRemoveUserTempDataFromMapParam,
  removeUserTempDataFromMap,
} from '../../utils/remover/removeUserTempData.util';
import {
  ISetUserTempDataToMapParam,
  setUserTempDataMapToStorage,
  setUserTempDataToMap,
} from '../../utils/setter/setUserTempData.util';
import { useGetUserProfile } from '../user/useGetUserProfile';

interface IUseUserTempData {
  getUserTempData: (userId?: string) => {
    userTempData: IUserTempData;
  };
  setUserTempData: ({ userId, newTempData }: ISetUserTempDataToMapParam) => void;
  removeUserTempData: ({ userId, dataKey }: IRemoveUserTempDataFromMapParam) => void;
}

export const useUserTempData = (): IUseUserTempData => {
  const { userProfile } = useGetUserProfile();

  const get = (userId?: string) => getUserTempData(userId ?? userProfile?.id);
  const set = ({ userId, newTempData }: ISetUserTempDataToMapParam) => {
    const { newTempDataMap } = setUserTempDataToMap({ userId: userId ?? userProfile?.id, newTempData });
    setUserTempDataMapToStorage({ newTempDataMap });
  };
  const remove = ({ userId, dataKey }: IRemoveUserTempDataFromMapParam) => {
    const { newTempDataMap } = removeUserTempDataFromMap({ userId: userId ?? userProfile?.id, dataKey });
    setUserTempDataMapToStorage({ newTempDataMap });
  };

  return { getUserTempData: get, setUserTempData: set, removeUserTempData: remove };
};
